export default "__VITE_ASSET__58dc94ae__"